// English UI translations
export const en = {
    // Common
    common: {
        save: "Save",
        cancel: "Cancel",
        finish: "Finish",
        delete: "Delete",
        edit: "Edit",
        add: "Add",
        remove: "Remove",
        close: "Close",
        apply: "Apply",
        search: "Search",
        filter: "Filter",
        period: "Period",
        loading: "Loading...",
        saving: "Saving...",
        error: "Error",
        success: "Success",
        confirm: "Confirm",
        yes: "Yes",
        no: "No",
        ok: "OK",
        back: "Back",
        backToHome: "Back to Home",
        next: "Next",
        previous: "Previous",
        select: "Select",
        all: "All",
        none: "None",
        settings: "Settings",
        options: "Options",
        actions: "Actions",
        status: "Status",
        date: "Date",
        amount: "Amount",
        companyName: "Company name",
        currency: "Currency",
        description: "Description",
        name: "Name",
        total: "Total",
        duplicate: "Duplicate",
        shareLink: "Share link",
        selected: "selected",
        showing: "Showing",
        of: "of",
        noInvoicesFound: "No invoices found",
        noExpensesFound: "No expenses found",
        tryChangingQuery: "Try changing your search query",
        startByCreating: "",
        createFirstInvoice: "Create first invoice",
        createFirstExpense: "Add first expense",
        language: "Language",
        logout: "Logout",
        create: "Create",
        home: "Home",
        optional: "Optional",
    },

    // Transfer Invoices
    transferInvoices: {
        title: "TRANSFER INVOICES FROM ANOTHER SYSTEM",
        menuLabel: "TRANSFER INVOICES",
        description: "We'll be happy to help you transfer your invoices from any other system for the last tax period. We'll do it for free within 3 business days (maximum 50 invoices per 1 year).",
        aiTransferTitle: "If you don't want to wait, you can try transferring the data from your invoices yourself.",
        aiTransferDescription: "To do this, copy the instructions for your AI chat (we recommend using ChatGPT) using the {button} button and add the copied text from your invoices. Paste the received response into the form below and click the 'Create Invoices Automatically' button.",
        setupRequired: "To do this, fill out the form below:",
        prefilledText: "Hello, I would like to transfer the following invoices:",
        storageLink: "Link to file storage (e.g., Google Drive)",
        storageLinkPlaceholder: "Make sure the link is accessible to everyone",
        emailNote: "If you want to send files via email, write to us at {email}",
        submit: "Send request",
        manualSubmitButton: "Send manual request",
        autoSubmitButton: "Create Invoices Automatically",
        jsonDataLabel: "Data for automatic creation (JSON format)",
        jsonDataPlaceholder: "Paste your JSON here for automatic processing...",
        jsonDataHelp: "If you have data in our JSON format, you can paste it here for automatic invoice creation.",
        success: "Request sent! We will contact you shortly.",
        autoSuccess: "{count} invoices created automatically!",
        specificationButton: "Specification",
        copyLlmButton: "Copy LLM instructions",
        llmInstructionsTitle: "Instruction copied!",
        llmInstructionsDescription: "You can now paste this prompt into your LLM (ChatGPT, Claude, etc.) to convert your data.",
        specificationTitle: "JSON Specification",
    },
    expenses: {
        title: "Expenses",
        addExpense: "Add Expense",
        editExpense: "Edit Expense",
        expenseName: "Name / Vendor",
        category: "Category",
        date: "Date",
        amount: "Amount",
        currency: "Currency",
        note: "Note",
        manageTitle: "Manage Expenses",
        deleteConfirm: "Are you sure you want to delete this expense?",
        validationMessage: "Please enter a name and amount",
        categories: {
            subscriptions: "Subscriptions & Services",
            consulting: "Consulting",
            communication: "Communication",
            education: "Education",
            equipment: "Equipment",
            marketing: "Advertising / Marketing",
            rent: "Office / Rent",
            software: "Software / SaaS",
            supplies: "Supplies",
            travel: "Travel",
            salary: "Salaries",
            taxes: "Taxes",
            other: "Other"
        }
    },
    // Support
    support: {
        miniLabel: "Not enough functionality? Something not working? Have questions?",
        button: "SUPPORT",
        modalTitle: "Technical Support",
        modalSubtitle: "We work 7 days a week.",
        modalEmailLabel: "Write to email",
        modalNote: "Use the email address you used to register your account.",
    },

    // Invoice App
    invoice: {
        invoiceGenerator: "Invoice Generator",
        invoiceBasics: "Invoice Basics",
        parties: "Parties",
        subtotal: "Subtotal",
        grandTotal: "Grand total",
        save: "Save",
        saving: "Saving...",
        saved: "Saved",
        notSaved: "Not saved",
        invoiceNumber: "Invoice number",
        issueDate: "Issue date",
        dueDate: "Due date",
        customer: "Customer",
        address: "Address",
        buyerId: "Buyer ID",
        loadDefaults: "Configure default data",
        sellerInfo: "Seller Information",
        country: "Country",
        notes: "Notes",
        identificationNumber: "IČO (Tax ID)",
        dic: "DIČ (VAT Identification Number)",
        czechSoleProprietor: "I am a Sole Proprietor in Czech Republic",
        czechSoleProprietorTooltip: "Adds required legal information to the invoice",
        paymentInfo: "Payment Information",
        items: "Items",
        addItem: "Add item",
        pricePerUnit: "Price per unit",
        note: "Note",
        downloadPdf: "Download PDF",
        print: "Print (dialog)",
        sendByEmail: "Send by email",
        saveInvoiceFirst: "Save invoice first",
        newInvoice: "New invoice",
        invoiceNumberRequired: "Please enter an invoice number to save or download",
        invoiceNumberEmpty: "Invoice number is required",
        comingInFebruary: "Coming in February, stay tuned for updates!",
        printNote: "When printing via dialog, uncheck 'Headers'. The 'Download PDF' button removes everything automatically.",
        daysUntilDue: "Days until due",
        dueDateSettings: "Due date settings",
        dueDateExplanation: "Set the default number of days for payment due date. This will be applied to new invoices.",
        invoiceLanguage: "Invoice Language",
        invoiceNumberTemplate: "Invoice Number Template",
        invoiceNumberTemplateTooltip: "Invoice number template settings",
        paymentOptions: "Payment Options",
        addPaymentOption: "Add payment option",
        paymentType: "Payment Type",
        paymentTitle: "Title",
        paymentDetails: "Details",
        bankTransfer: "Bank Transfer",
        onlinePayment: "Online Payment",
        cash: "Cash Payment",
        custom: "Custom",
        paymentUponDelivery: "Payment upon delivery or pickup",
        enterCustomPaymentDetails: "Enter custom payment details",
        paymentMethodBankingDetails: "Payment method and banking details",
        removePaymentOption: "Remove",
        businessLogo: "Business Logo",
        uploadLogo: "Upload Logo",
        removeLogo: "Remove Logo",
        website: "Website",
        websiteText: "Website Text",
        issuedBy: "Issued by",
        acceptedBy: "Accepted by",
        signature: "Signature",
        uploadSignature: "Upload Signature",
        removeSignature: "Remove Signature",
        vatPayer: "VAT Payer?",
        nonVatPayer: "Non-VAT Payer",
        notSpecified: "Not specified",
        taxSettings: "Tax Settings",
        enableVat: "Enable VAT",
        vatRate: "VAT Rate (%)",
        vat: "VAT",
        netAmount: "Net Amount",
        vatAmount: "VAT Amount",
        totalAmount: "Total Amount",
        discount: "Discount",
        quantity: "Amount",
        price: "Price",
        unit: "Unit",
        discountPercent: "Discount (%)",
        applyDiscount: "Apply Discount",
        itemDiscount: "Item Discount",
        totalDiscount: "Total Discount",
        addCustomTax: "Add Custom Tax",
        taxName: "Tax Name",
        taxAmount: "Tax Amount",
        taxPercentage: "Tax Percentage",
        fixedAmount: "Fixed Amount",
        percentage: "Percentage",
        czechMarket: "For Czech market",
        internationalMarket: "For international market",
        accountNumber: "Account Number",
        bankName: "Bank Name",
        bankAddress: "Bank Address",
        variableSymbol: "Variable Symbol",
        constantSymbol: "Constant Symbol",
        specificSymbol: "Specific Symbol",
        paymentLink: "Payment Link",
        paymentUrl: "Payment URL",
        linkText: "Link Text",
        account: "Account",
        bank: "Bank",
        showQRCode: "Show QR code (valid for Czech banks only!)",
        invoiceStatus: "Invoice Status",
        status: "Status",
        managePaymentMethods: "Manage payment methods",
        manageClients: "Manage saved clients",
        manageSavedItems: "Manage saved items",
        templateButton: "Template",
        manageButton: "Manage",
        savedPaymentMethods: "Saved Payment Methods",
        selectPaymentMethod: "Select payment method",
        addSaved: "Add saved",
        descriptionPlaceholder: "Service / product description",
        unitPlaceholder: "pcs",
        units: {
            pcs: "pcs",
            hours: "hours",
            days: "days",
            months: "months",
            kg: "kg",
            unit: "unit",
            liters: "liters",
            m: "m",
            m2: "m²",
            m3: "m³",
        },
        noSavedMethods: "No saved payment methods found",
        selectSavedPaymentMethod: "Select saved payment method",
        useExistingPaymentInfo: "Use existing payment information to automatically create payment options, or add them manually.",
        autoPopulate: "Auto-populate from existing data",
        saveAsTemplate: "Save this configuration as a template",
        onboarding: {
            startTitle: "How to issue invoices in Invoitio? Learn in 2 minutes.",
            startButton: "Start training",
            skipButton: "Skip",
            tutorialButton: "Tutorial",
            trainingLocation: "Training is always here. If you don't understand how to do something, activate it on any page!",
            steps: {
                basics: {
                    title: "Invoice Basics",
                    description: "Here you can choose the language, and due date of the invoice, as well as change its number.",
                },
                template: {
                    title: "Templates",
                    description: "Click here to configure the automatic numbering template for your invoices.",
                },
                dueDate: {
                    title: "Due Date",
                    description: "You can configure the due date via the date field or via the number of days by clicking the settings button.",
                },
                parties: {
                    title: "Parties",
                    description: "Fill in the seller and client information. Switch between them using the tabs.",
                },
                manageClients: {
                    title: "Manage Clients",
                    description: "Save client details here to select them with one click in the future.",
                },
                items: {
                    title: "Items",
                    description: "Add services or products. The subtotal and taxes will be calculated automatically.",
                },
                payment: {
                    title: "Payment Methods",
                    description: "Choose payment methods. You can save them as templates for quick insertion.",
                },
                status: {
                    title: "Invoice Status",
                    description: "Track the payment lifecycle. 'Overdue' status is updated automatically for 'Pending' invoices if they aren't marked as paid. You can also set up automatic customer notifications in the 'Customer Notifications' menu.",
                },
                save: {
                    title: "Save Invoice",
                    description: "Be sure to click the Save button if you want to save the data in the invoice!",
                },
                final: {
                    title: "Most Important!",
                    description: "To ensure your invoice meets formal requirements in the Czech Republic, fill in ALL fields related to legal information in the sections: Client, Seller Information, at least 1 payment method, and at least one item or service.",
                    button: "Understood!"
                }
            }
        },
        validation: {
            modalTitle: "Incomplete Invoice",
            modalMessage: "The following mandatory fields are not filled in: {fields}. Are you sure you want to keep the invoice like this?",
            modalMessageDownload: "The following mandatory fields are not filled in: {fields}. Are you sure you want to keep the invoice like this?",
            fixButton: "Fix",
            continueButton: "Continue",
            downloadButton: "Download",
            okButton: "Save",
            errorRequired: "This field is required",
            errorRequiredWarning: "Fill in if the client is not a natural person, otherwise it's not a mandatory field",
            sectionError: "Please fill in the required fields in this section",
            aresButton: "Auto-fill company details from CZ (ARES)",
            aresLoading: "Loading...",
            aresNotFound: "Company not found",
            aresError: "Error fetching data",
            aresMinChars: "Enter at least 8 characters",
            fields: {
                invoiceNo: "Invoice Number",
                issueDate: "Issue Date",
                dueDate: "Due Date",
                sellerName: "Seller Name",
                sellerTaxId: "Seller IČO (Tax ID)",
                sellerVatNumber: "Seller DIČ (VAT ID)",
                sellerAddress: "Seller Address",
                buyerName: "Client Name",
                buyerTaxId: "Client IČO (Tax ID)",
                buyerVatNumber: "Client DIČ (VAT ID)",
                buyerAddress: "Client Address",
                buyerEmail: "Client Email",
                sellerEmail: "Seller Email",
                items: "Items (add at least one)",
                itemsValid: "Description and price for each item",
                paymentOptions: "Payment Method (select at least one)",
                paymentBank: "Bank details (Account number or IBAN)",
                paymentLink: "Payment link",
                paymentCustom: "Payment method description",
            }
        },
    },

    // Invoice List
    invoiceList: {
        title: "Invoice List",
        newInvoice: "New Invoice",
        searchPlaceholder: "Search invoices...",
        noInvoices: "No invoices found",
        columns: {
            invoiceNumber: "Invoice Number",
            client: "Client",
            description: "Description",
            amount: "Amount",
            issueDate: "Issue Date",
            dueDate: "Due Date",
            status: "Status",
            actions: "Actions",
        },
        invoiceStatus: "Invoice status:",
        status: {
            paid: "Paid",
            pending: "Pending",
            overdue: "Overdue",
        },
        actions: {
            edit: "Edit",
            delete: "Delete",
            download: "Download",
            downloadPdf: "Download PDF",
            archive: "Archive",
            changeStatus: "Change Status",
        },
        deleteModal: {
            title: "Delete Invoice",
            message: "Are you sure you want to delete this invoice? This action cannot be undone.",
            messageMultiple: "Are you sure you want to delete {count} selected invoices? This action cannot be undone.",
            confirm: "Delete",
            cancel: "Cancel",
        },
        settings: {
            title: "Default Invoice Settings",
            configureMyData: "CONFIGURE MY INVOICE DATA",
            sellerModalTitle: "Default Seller Details",
            sellerName: "Name",
            sellerTaxId: "IČO (Tax ID)",
            sellerVatNumber: "DIČ (VAT ID)",
            sellerWebsite: "Website",
            sellerAddress: "Address",
            sellerIsCzechSoleProprietor: "I am a Sole Proprietor in Czech Republic",
            sellerIsVatPayer: "VAT Payer",
            sellerNotes: "Notes",
            vatNotSpecified: "Not specified",
            vatPayer: "VAT Payer",
            vatNotPayer: "Non-VAT Payer",
            defaultDueDays: "Default Due Days",
            defaultDueDaysDescription: "Number of days until payment is due",
            defaultTemplate: "Default Template",
            invoiceStyle: "Invoice Style",
            defaultCurrency: "Default Currency",
            defaultLanguage: "Default Language",
            invoiceNumberTemplate: "Invoice Number Template",
            save: "Save",
            cancel: "Cancel",
            saved: "Settings saved successfully",
            saving: "Saving...",
        },
        onboarding: {
            startTitle: "Learn how to manage and configure invoices in 2 minutes",
            startButton: "Start Tutorial",
            skipButton: "Skip",
            trainingLocation: "Training is always here. If you don't understand how to do something, activate it on any page!",
            tutorialButton: "Tutorial",
            steps: {
                table: {
                    title: "Invoice Table",
                    description: "Here is the table where all your created invoices are displayed.",
                },
                actions: {
                    title: "Invoice Actions",
                    description: "In this column, you can download an invoice, share a secure link, send an email reminder, duplicate, or delete an invoice.",
                },
                bulk: {
                    title: "Bulk Actions",
                    description: "By selecting multiple invoices, you can bulk duplicate, delete, download an archive, or export to Excel.",
                },
                settings: {
                    title: "Default Settings",
                    description: "This is a very important section! Here you can configure data that will be automatically filled into all new invoices: language, seller information, currency, and number template.",
                },
                filters: {
                    title: "Filters",
                    description: "Use filters to quickly find the invoices you need or change how they are displayed in the list.",
                },
                newInvoice: {
                    title: "Create Invoice",
                    description: "To create a new invoice, just click this button!",
                }
            }
        },
        archive: {
            download: "Download Archive",
            downloading: "Downloading...",
            archiving: "Archiving invoices...",
            noSelection: "Please select invoices to archive",
        },
        errors: {
            statusChangeError: "Error changing status",
            deleteError: "Error deleting invoice",
            backendDeleteError: "Error deleting invoice from database",
            archiveError: "Error creating archive",
            backendNotAvailable: "Backend is not available. A text file was downloaded instead of a ZIP archive.",
        },
        filter: "Filter",
        filterSortBy: "Sort by",
        filterSortOrder: "Sort order",
        filterIssueDate: "Issue Date",
        filterAmount: "Amount",
        filterDueDate: "Payment Date",
        filterClientName: "Client Name",
        filterCreatedAt: "Creation Date",
        filterStatus: "Status",
        filterStatusSort: "By Status",
        filterAscending: "Ascending",
        filterDescending: "Descending",
        filterSelectField: "Select field",
        filterSelectOrder: "Select order",
        filterReset: "Reset",
    },

    // Statistics
    statistics: {
        title: "Statistics",
        totalRevenue: "Total Revenue",
        revenueByClient: "Revenue by Client",
        revenueByCurrency: "Revenue by Currency",
        revenueTimeline: "Revenue Timeline",
        baseCurrency: "Base Currency",
        selectYear: "Select Year",
        allYears: "All Years",
        year: "Year",
        month: "Month",
        client: "Client",
        revenue: "Revenue",
        income: "Income",
        expense: "Expense",
        totalExpenses: "Total Expenses",
        expensesByCategory: "Expenses by Category",
        expensesByCurrency: "Expenses by Currency",
        percentage: "Percentage",
        info: "Info",
        infoTooltip: "Exchange rates are fetched from the European Central Bank (ECB) for EU and supported currencies and updated in real time.\n\nLive rates are available for the following currency codes:\nEUR, USD, CZK, GBP, ARS, AUD, BGN, BRL, CAD, CHF, CNY, DKK, HKD, HRK, HUF, IDR, ILS, INR, ISK, JPY, KRW, MAD, MXN, MYR, NOK, NZD, PHP, PLN, RON, RUB, SEK, SGD, THB, TRY, TWD, ZAR.\n\nOther currencies are updated monthly. For these conversions, Swiss franc (CHF) is used as an intermediate currency.\n\nCHF is also used as an intermediate currency when calculating total income for all currencies except CZK, EUR, USD, and GBP, which are converted live using ECB exchange rates.",
        loadingRates: "Loading exchange rates...",
        noData: "No data available",
        arpu: {
            label: "Average Revenue Per User (ARPU)",
            period: "Period",
            formula: "Total Revenue ÷ Paying Customers",
            formulaLabel: "ARPU Formula:",
            formulaFull: "ARPU = Total Revenue ÷ Paying Customers (here per client)",
        },
        mrr: {
            label: "Monthly Recurring Revenue (MRR)",
            formula: "Paying Customers × ARPU",
            formulaLabel: "MRR Formula:",
            formulaFull: "MRR = (Total number of paying customers) × (Average Revenue Per User)",
        },
        netIncome: "Net Income (Revenue - Expenses)",
        avgMonthlyRevenue: "Average Monthly Revenue",
        avgMonthlyExpenses: "Average Monthly Expenses",
        includePending: "Include pending invoices in calculations?",
        statusDistribution: "Invoice Status Distribution",
        period: "Period",
        total: "Total",
        allTime: "All Time",
        currentMonth: "Current Month",
        previousMonth: "Previous Month",
        previousYear: "Previous Year",
        exportToExcel: "Export to Excel",
        exportModal: {
            title: "Export to Excel",
            selectRange: "Select time range",
            from: "From",
            to: "To",
            tableLanguage: "Table Language",
            download: "Download"
        },
    },

    // Invoice Templates
    invoiceTemplates: {
        title: "Invoice Templates",
        comingSoon: "Coming Soon",
        description: "Create and manage your own invoice templates to speed up your workflow.",
        createTemplate: "Create Template",
    },

    // Repeating Invoices
    repeatingInvoices: {
        title: "Repeating Invoices",
        step1: "Step 1 - select an invoice for repetition",
        step2: "Step 2 - choose the interval",
        everyMonthDay: "I want to issue every",
        dayOfMonth: "day of the month",
        lastDayNote: "* If the month has fewer days, the last day of the month will be used",
        or: "— OR —",
        intervalLabel: "I want to issue an invoice every",
        days: "days",
        fromDate: "From",
        toDate: "To",
        templateNameLabel: "Template Name",
        templateNamePlaceholder: "e.g. Monthly invoice for E-Corp Inc.",
        optional: "(optional)",
        createButton: "Create Multiple Invoices",
        managementTitle: "Manage Repeating Invoices",
        noTemplates: "You don't have any repeating invoice templates yet.",
        noTemplatesSub: "Select an invoice and configure the repetition settings above to create your first template.",
        deleteConfirm: "Are you sure you want to delete this repeating invoice template?",
        successCreated: "Done! You have successfully created {count} invoices",
    },

    // Client Notifications
    clientNotifications: {
        title: "Client Notifications",
        setupNotice: "Before you start using notifications, please configure:",
        setupAlwaysChange: "You can always change this in General Settings -> Email address for client notifications",
        setupRequiredTitle: "Setup Required",
        setupRequiredDescription: "Please fill in and save your sender name and email handle above to unlock the reminder sections.",
        manualSection: "Manual Reminder Dispatch",
        manualStep1: "Step 1 - Select email template",
        manualStep2: "Step 2 - Select an invoice to send",
        emailLangLabel: "Email language",
        manualEditNotice: "You will have the opportunity to edit the email before sending in the 'Preview and send' step",
        autoEditNotice: "You will have the opportunity to edit the email before sending in the 'Preview and reminder setup' step below.",
        previewAndSend: "Preview and send",
        allInvoices: "All Invoices",
        overdueInvoicesOnly: "Overdue Invoices",
        overdueInvoices: "Overdue Invoices",
        reminderSent: "Reminder sent successfully!",
        reminderError: "Failed to send reminder. Please check your settings or the client's email address.",
        noEmailError: "This client does not have an email address.",
        noInvoicesFound: "No invoices found.",
        howItWorksTitle: "HOW DOES IT WORK?",
        howItWorksDescription: "Automatic reminders are configured globally for a specific saved client. To make them work, make sure that when creating new invoices, you select a client from the saved list using the \"Select client\" field and {clientLink} on the {appLink}. If you want to send a reminder only for one specific invoice, use the {manualLink} section above.",
        clientLink: "\"Manage saved clients\"",
        appLink: "create new invoice page",
        manualLink: "\"Manual dispatch\"",
        autoSection: "Automatic Reminder Configuration",
        autoStep1: "Step 1 - Select a client",
        autoStep2: "Step 2 - Configuration",
        autoIntervalLabel: "I want to send automatic reminders to the client",
        autoIntervalShort: "Send after",
        daysAfterDue: "days after overdue payment",
        emailTemplateLabel: "Email template I want to use:",
        emailTemplateShort: "Template",
        standardTemplateChoice: "Use standard template in",
        saveSettings: "Preview and reminder setup",
        sendManual: "Send Reminder",
        confirmModalTitle: "This is what the email for the client will look like:",
        recipientEmailLabel: "Client Email:",
        sendTo: "send to",
        editEmail: "Edit email",
        save: "Save",
        invoiceDownloaded: "Invoice downloaded, you can take a look at it",
        missingFieldsTitle: "The following data is missing in the invoice or email:",
        missingFieldsNote: "Change the {invoiceLink} itself and the text below by clicking the 'Edit email' button",
        invoiceLink: "invoice",
        emailNotConfiguredTitle: "Email for sending is not configured",
        emailNotConfiguredDescription: "You need to go to {link} and configure your email address to be able to send notifications.",
        notificationsLink: "Client Notifications",
        emailMissingTitle: "Missing Email Address",
        emailMissingDescription: "This client doesn't have an email address. You must add one in 'Manage Saved Clients' before you can set up automatic reminders.",
        noOverdue: "No overdue invoices found.",
        noInvoicesTitle: "No Invoices Yet",
        noInvoicesDescription: "Create your first invoice to start using the reminder system for your clients.",
        createFirstInvoice: "Create First Invoice",
        previewInstructionAuto: "To see what the sent email will look like, create your first invoice and select it in this section for preview!",
        previewInstructionManual: "For preview, select an invoice by clicking on a row in Step 2",
        noClients: "No clients found.",
        searchInvoices: "Search overdue invoices...",
        searchClients: "Search clients...",
        placeholderCompany: "Your Company Name",
        placeholderPayment: "{paymentDetails}",
        customTemplateChoice: "Custom Text",
        manageAutoSection: "Manage Automatic Reminders",
        reminderFor: "Reminder for",
        lastSent: "Last sent",
        neverSent: "Never",
        activeStatus: "Active",
        inactiveStatus: "Paused",
        noAutoReminders: "No automatic reminders configured.",
        deleteReminderConfirm: "Are you sure you want to stop automatic reminders for this client?",
        actions: {
            sendReminder: "Send reminder"
        }
    },

    // Client Dialog
    clientDialog: {
        title: "Client",
        manageTitle: "Manage Clients",
        addTitle: "Add New Client",
        editTitle: "Edit Client",
        name: "Name",
        address: "Address",
        email: "Email",
        phone: "Phone",
        taxId: "Tax ID",
        buyerId: "Buyer ID",
        namePlaceholder: "Client name",
        addressPlaceholder: "Client address",
        buyerIdPlaceholder: "ID: 12345678",
        selectClient: "Select client",
        existingClients: "Existing Clients",
        noClients: "No clients added yet.",
        add: "Add Client",
        update: "Update Client",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        deleteConfirm: "Are you sure you want to delete this client?",
        validationMessage: "At least one field must be filled",
    },

    // Payment Method Dialog
    paymentMethodDialog: {
        title: "Payment Method",
        manageTitle: "Manage Payment Methods",
        addTitle: "Add New Payment Method",
        editTitle: "Edit Payment Method",
        type: "Type",
        titleLabel: "Title",
        details: "Details",
        accountNumber: "Account Number",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bankName: "Bank Name",
        bankAddress: "Bank Address",
        variableSymbol: "Variable Symbol",
        constantSymbol: "Constant Symbol",
        specificSymbol: "Specific Symbol",
        paymentUrl: "Payment URL",
        linkText: "Link Text",
        savedMethods: "Saved Payment Methods",
        noMethods: "No payment methods saved yet.",
        add: "Add Payment Method",
        update: "Update Payment Method",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        deleteConfirm: "Are you sure you want to delete this payment method?",
        validationMessage: "Title and at least one other field must be filled",
        bankTransfer: "Bank Transfer",
        paymentLink: "Payment Link",
        cash: "Cash",
        custom: "Custom",
        titlePlaceholderBank: "Bank Transfer",
        titlePlaceholderLink: "Pay Online",
        titlePlaceholderCash: "Cash",
        titlePlaceholderCustom: "Custom Payment",
        detailsPlaceholderCash: "Cash payment upon delivery or pickup",
        detailsPlaceholderCustom: "Enter custom payment details",
    },

    // Landing Page
    landing: {
        hero: {
            title: "Ready invoice in 10 seconds",
            subtitle: "Sending invoices by email and via messengers directly from the app, expense and profit tracking, QR code payments. The most convenient invoicing service for freelancers, startups, and small businesses in the Czech Republic and the European Union.",
            tryButton: "Try Invoitio free for 30 days",
            noCardRequired: "💳🚫 No card required",
            madeInCzech: "Made in Czech Republic",
            womenOwned: "Women-owned",
        },
        nav: {
            tryIt: "Try it",
            functionality: "Features",
            pricing: "Pricing",
            faq: "FAQ",
            invoiceList: "Blog",
            login: "Login",
            start: "Start free",
            contact: "Contact us",
        },
        features: {
            title: "Features",
            voiceInput: "1 sentence instead of endless forms",
            voiceInputDescription: "You speak — Invoitio calculates and issues an invoice. Fast and error-free.",
            reports: "Profit Reports",
            reportsDescription: "Clear charts instead of manual calculations — save your accountant's time.",
            reminders: "Overdue Payment Reminders",
            remindersDescription: "Client didn't pay on time? Invoitio will remind you — politely and on time.",
            mobile: "Mobile Device Support",
            mobileDescription: "Interface works on any device.",
            storage: "Reliable Storage",
            storageDescription: "All invoices in one place, with quick search.",
            languages: "Support for 5 Languages",
            languagesDescription: "English, Czech, Slovak, German and Russian. Plus field customization.",
            modern: {
                unlimited: "No limits on invoices and number of users",
                analytics: "One clear overview of profit and expenses with metrics",
                repeating: "Repeating invoices - create them in one click for regular clients",
                send: "Send invoices via e-mail and messengers",
                multi: "Any currency, 5 interface and invoice languages, QR code",
                notSure: "Still not sure?",
                fullList: "Full feature list",
                roadmapTitle: "Upcoming Features",
            },
            grid: {
                transfer: "Free transfer of your invoices from the last year. Even during the trial period!",
                security: "Your data is safe. We use encryption to protect your data both in transit and at rest.",
                eu_servers: "🇪🇺 Servers only in the European Union",
                charts: "Visual income and expense charts",
                messengers: "Send invoices to messengers – WhatsApp, Telegram, and others directly from the app.",
                ecb_rates: "Real-time exchange rates from the European Central Bank",
                excel_export: "Export to Excel to make tax reporting simple and convenient.",
                expense_tracking: "Expense tracking",
                password_links: "Password-protected invoices via a unique link.",
                qr_codes: "QR code for payment in the invoice for Czech banks",
                website_link: "Link to your website directly in the invoice",
                templates: "Invoice templates – save your data, payment methods, and easily insert or copy them",
            },
            roadmap: {
                feb1: "Automatic invoice sending and auto-reminders for unpaid invoices",
                feb1_date: "February 2026",
                feb2: "Time tracking and time-based invoicing",
                feb2_date: "February 2026",
                mar: "Bank synchronization for automatic payment tracking",
                mar_date: "March 2026",
                apr: "Warehouse – inventory management system linked to invoices",
                apr_date: "April 2026",
            },
            detailed: {
                feature1: "5 interface and invoice languages: English, Czech, Slovak, German, and Russian.",
                feature2: "Add any payment methods and links directly into your invoice + QR payment.",
                feature3: "Any currency.",
                feature4: "Send invoices directly from Invoitio — save time searching for contacts :)",
                feature3a: "No limits in the full version: unlimited invoices, clients, and suppliers.",
                feature3b: "Unified report of profit and costs in your chosen currency.",
                feature3c: "Export for accountants + separate accountant access.",
                feature3d: "Compliance across multiple jurisdictions.",
                feature5: "Advanced income analytics: MRR, LTV, ARPU, streams of income and more, supporting all currencies.",
            },
        },
        pricing: {
            title: "Price that works for you",
            subtitle: "",
            limitedDiscount: "LIMITED 15% DISCOUNT",
            monthly: "Monthly Subscription",
            monthlyPrice: "220 Kč",
            monthlyOldPrice: "253 Kč",
            monthlyPeriod: "/ month",
            yearlyMainPrice: "133 Kč",
            yearlyOldMainPrice: "153 Kč",
            yearlyMainPeriod: "/ month",
            yearlySubscriptionText: "with subscription",
            yearlySubPrice: "1600 Kč per year",
            oneYear: "One-Year Pass",
            oneYearPrice: "1600 Kč",
            oneYearOldPrice: "1840 Kč per year",
            oneYearPeriod: " / year",
            oneYearButton: "Get Invoitio now",
            trustedBy: "Trusted by 2500+ users",
            lifetime: "Life-time Access",
            lifetimePrice: "3960 Kč",
            lifetimeOldPrice: "4554 Kč",
            lifetimePeriod: " one-time",
            beneficial: "Best Deal",
            mostPopular: "Most Popular",
            hoursUntilPriceIncrease: "8 hours until price increase",
            features: {
                allFeatures: "All Invoitio functions",
                twoDevices: "2 devices: you and accountant",
                support: "Support",
                forever: "Forever — no subscriptions",
                allFuture: "All current and future functions",
                priority: "Priority support",
            },
            start: "Start",
            buy: "Buy",
        },
        faq: {
            title: "Frequently Asked Questions",
            subtitle: "Answers to popular questions about Invoitio",
            question0: "Can I transfer invoices from another system to Invoitio?",
            answer0: "We will transfer invoices from your current tax period to our system for free (even during the trial period).",
            question1: "Do you have an affiliate program?",
            answer1: "Yes, we do have an affiliate program for all our users! You get 30% lifetime recurring commission on referrals. If you are interested in participating in the referral program, [register your account] and go to [settings] to copy the referral link.",
            question2: "Can I use Invoitio for free?",
            answer2: "Yes! You can try Invoitio for free for 30 days. After that, monthly, annual, and lifetime plans are available.",
            question5: "How does Invoitio help with overdue payments?",
            answer5: "(from February 2026) The system automatically tracks payment deadlines and sends reminders to clients about overdue payments. You can also set up automatic notifications.",
            question6: "Can I export invoicing data to other systems?",
            answer6: "Yes, Invoitio allows exporting invoices to PDF and Excel (.xlsx) formats. In 2026, XML and ISDOC export for accounting systems, such as Pohoda or Money S3, will be integrated.",
            question7: "How many languages does Invoitio support?",
            answer7: "Invoitio supports 6 languages: English, Czech, Slovak, German, Russian and Ukrainian. You can create invoices and use the application in any of these languages.",
            answer7SignUp: "",
            answer7SignUpButton: "",
            answer7UserSettings: "",
            answer7UserSettingsButton: "",
            answer7Where: "",
            stillHaveQuestions: "Still have questions?",
        },
        cta: {
            title: "Start free right now",
            subtitle: "Create invoices in 10 seconds and get your financial reports instantly.",
            createAccount: "Create Account",
            viewDemo: "View Demo",
        },
        questions: {
            title: "Still have questions? We'll be happy to answer",
        },
        footer: {
            privacy: "Privacy Policy",
            terms: "Terms",
            copyright: "© {year} Invoitio",
        },
        auth: {
            loginTitle: "Sign in to your account",
            resetTitle: "Reset your password",
            resetDescription: "Enter your email and we will send you a link to reset your password.",
            email: "Email",
            password: "Password",
            signIn: "Sign in",
            forgotPassword: "Forgot password?",
            sendResetLink: "Send reset link",
            backToLogin: "Back to sign in",
            rememberMe: "Remember me",
            signUp: "Sign up",
            noAccount: "Don't have an account?",
            alreadyHaveAccount: "Already have an account?",
            passwordRequirements: "Password must be at least 8 characters long and contain at least 1 lowercase and 1 uppercase letter and 1 number.",
            errors: {
                PASSWORD_TOO_SHORT: "Password must be at least 8 characters long, contain at least 1 uppercase, 1 lowercase letter and 1 number",
                PASSWORD_TOO_LONG: "Password must be no more than 128 characters and contain uppercase, lowercase letters, and numbers",
                PASSWORD_MISSING_UPPERCASE: "Password must be at least 8 characters long, contain at least 1 uppercase, 1 lowercase letter and 1 number",
                PASSWORD_MISSING_LOWERCASE: "Password must be at least 8 characters long, contain at least 1 uppercase, 1 lowercase letter and 1 number",
                PASSWORD_MISSING_NUMBER: "Password must be at least 8 characters long, contain at least 1 uppercase, 1 lowercase letter and 1 number",
                PASSWORD_INVALID_TYPE: "Password must be a valid string",
                EMAIL_REQUIRED: "Email is required",
                PASSWORD_REQUIRED: "Password is required",
                EMAIL_INVALID: "Invalid email format",
                INVALID_CREDENTIALS: "Invalid email or password",
                USER_ALREADY_EXISTS: "User with this email already exists",
                AUTHENTICATION_REQUIRED: "Authentication required",
                TOKEN_INVALID: "Invalid or expired token",
                TOKEN_EXPIRED: "Token has expired",
                FAILED_TO_PROCESS: "Failed to process request. Please try again later.",
                FAILED_TO_RESET: "Failed to reset password. Please try again later.",
                RESET_LINK_SENT: "If an account exists with that email, we have sent password reset instructions.",
            },
        },
        registrationSuccess: {
            title: "Please confirm your email",
            myLanguage: "My language:",
            languages: {
                cs: "🇨🇿 Czech",
                en: "🇬🇧 English",
                ru: "Russian"
            },
            checkInboxBeforeEmail: "Please check your inbox",
            checkInboxAfterEmail: "and click the verification link to activate your account.",
            didntReceive: "Didn't receive the email?",
            checkSpam: "Check your spam folder",
            makeSureCorrect: "Make sure the email address is correct",
            waitMinutes: "Wait a few minutes and try again",
            continueToDashboard: "Continue to Dashboard"
        },
        verifyEmail: {
            verifying: "Verifying your email...",
            wait: "Please wait while we verify your email address.",
            verified: "Email Verified!",
            success: "Your email has been verified successfully!",
            alreadyVerified: "Your email is already verified. You can now login.",
            failed: "Verification Failed",
            noToken: "No verification token provided",
            goDashboard: "Go to Dashboard",
            goLogin: "Go to Login",
            signUpAgain: "Sign Up Again"
        },
        resetPassword: {
            title: "Reset Your Password",
            newPassword: "New Password",
            confirmPassword: "Confirm Password",
            saveButton: "Save New Password",
            resetting: "Resetting...",
            success: "Password Reset!",
            redirecting: "Redirecting to dashboard...",
            invalidLink: "Invalid Link",
            invalidLinkDescription: "This password reset link is invalid or missing.",
            backToLogin: "Go to Login",
            passwordsDoNotMatch: "Passwords do not match",
        },
        testimonials: {
            title: "Trusted by",
            subtitle: "Freelancers, studios and small companies from 12 countries",
            testimonial1: {
                name: "Maria, designer",
                text: "Reduced time on invoices from 20 minutes a day to 5.",
            },
            testimonial2: {
                name: "Studio Nord",
                text: "Switched from competitor: cheaper and more flexible fields.",
            },
            testimonial3: {
                name: "Anton, dev shop",
                text: "Payments started coming 30% faster.",
            },
        },
        testimonialsSection: {
            title: "Customer reviews",
            testimonial1: {
                text: "Sending invoices directly from the app saves a huge amount of time. The ability to issue invoices in any currency and in the required language is a major advantage. I’m very happy with both the simplicity and speed of the app, and especially with its competitive pricing compared to alternatives and the absence of limits on invoice creation. Thanks, great job! :)",
                name: "Josef",
                role: "Entrepreneur",
                img: "/josef.png",
            },
            testimonial2: {
                text: "Previously, I managed my invoices using an old app and Google Sheets — it was inconvenient. With Invoitio, everything is in one place: invoices, expenses, income, and key metrics important for startups. I especially value the consolidated report in a single currency and the export for my accountant — it has significantly simplified my workflow and reduced accounting costs during tax reporting.",
                name: "Kateřina",
                role: "Entrepreneur",
                img: "/katerina.png",
            },
        },
        team: {
            title: "Who built this?",
            members: {
                alice: {
                    name: "Alice",
                    role: "Founder",
                    bio: "{link}. Worked with big names like Canva and Wargaming. Loves making complex things simple.",
                    bioLinkText: "Senior software engineer of 6 years"
                },
                natalie: {
                    name: "Natalie",
                    role: "Marketing specialist",
                    bio: "She’s also a chemist (wow!) Loves making little things big."
                },
                jana: {
                    name: "Jana A.",
                    role: "Manual Testing Engineer"
                },
                renata: {
                    name: "Renata G.",
                    role: "Front-end Engineer & Manual Testing Engineer"
                },
                simon: {
                    name: "Simon R.",
                    role: "Senior Back-end Engineer - consultant"
                }
            }
        },
    },
    contact: {
        websiteBy: "website by kiki-mori studio",
    },
    notFound: {
        title: "Page not found",
        subtitle: "The page you are looking for doesn't exist or has been moved.",
        cta: "Start Invoitio free",
    },
    terms: {
        title: "Terms of Service",
        sections: [
            {
                title: "1. Provider Information",
                paragraphs: [
                    "The software-as-a-service platform Invoitio (\"Service\") is operated by the following provider:",
                    "Provider: Alisa Zakhtarenko, OSVČ",
                    "IČO: 21512302",
                    "Registered address: Praha – Vinohrady, Mánesova 1080/3, 12000",
                    "VAT status: Non-VAT payer (Neplátce DPH)",
                    "Contact: support [at] invoitio [dot] com",
                    "These Terms govern the use of the Service provided by the Provider.",
                ],
            },
            {
                title: "2. Description of the Service",
                paragraphs: [
                    "The Service is an online SaaS platform accessible via a user account.",
                    "Users receive access to the Service's functionality; no ownership rights to the underlying software, code, or content are transferred.",
                    "The Service is licensed, not sold.",
                ],
            },
            {
                title: "3. Account Registration and Use",
                paragraphs: [
                    "By creating an account, users agree to provide accurate and complete information.",
                    "The Provider may limit, suspend, or terminate access in cases including:",
                ],
                list: [
                    "misuse or abusive behavior,",
                    "security risks,",
                    "violation of these Terms.",
                ],
                paragraphsAfterList: [
                    "Users agree to use the Service responsibly and in compliance with applicable laws.",
                ],
            },
            {
                title: "4. Pricing, Payments and Billing",
                paragraphs: [
                    "Pricing is available on the website or within the application.",
                    "Subscriptions are billed at the start of each billing period.",
                    "If payment cannot be processed, access may be temporarily restricted until the issue is resolved.",
                    "Invoices are issued electronically.",
                ],
            },
            {
                title: "5. Subscription and Auto-Renewal",
                paragraphs: [
                    "Subscriptions renew automatically at the end of each billing period.",
                    "Auto-renewal may be disabled at any time in the application interface.",
                    "If you experience any difficulties with billing or cancellation, please contact: support [at] invoitio [dot] com",
                ],
            },
            {
                title: "6. Refund Policy",
                paragraphs: [
                    "Refunds are generally not offered.",
                    "However, if technical issues originating from the Service prevent users from cancelling a subscription or accessing billing controls, the Provider may issue a refund for the affected billing period.",
                    "Refunds may also be considered individually in exceptional circumstances.",
                ],
                subsections: [
                    {
                        title: "6.1 Cancellation Policy",
                        paragraphs: [
                            "Users may cancel their subscription at any time through the application interface.",
                            "Monthly subscriptions: Users retain access until the end of the current billing period.",
                            "All other subscription types: Cancellation follows the same policy as lifetime access; access remains valid only while the Service continues to operate.",
                            "Cancellation does not automatically result in a refund unless technical issues (as defined above) prevented proper cancellation.",
                        ],
                    },
                ],
            },
            {
                title: "7. Lifetime Access",
                paragraphs: [
                    "If the Service offers a \"lifetime access\" option, this refers to access for the operational lifetime of the Service, not the lifetime of the user.",
                    "If the Service or business is discontinued, becomes unprofitable, legally impossible to operate, or otherwise ceases, all forms of access — including lifetime access — will end.",
                    "No refunds or further obligations shall apply beyond the operational lifetime of the Service.",
                    "Monthly subscribers always retain access until the end of their billing period, even if the Service is scheduled to discontinue.",
                    "All other subscription types follow the same rules as lifetime access.",
                ],
            },
            {
                title: "8. Intellectual Property",
                paragraphs: [
                    "All software, source code, design, branding, the name Invoitio, and all related content are the exclusive intellectual property of the Provider.",
                    "Users receive a limited, non-exclusive, non-transferable license to use the Service for its intended purpose only.",
                    "The following actions are strictly prohibited:",
                ],
                list: [
                    "copying or reproducing the Service or any part of it,",
                    "modifying, adapting, translating, or creating derivative works,",
                    "reverse-engineering, decompiling, or attempting to extract source code,",
                    "misusing the Invoitio name, logo, branding, or design elements in the user's own products,",
                    "distributing, reselling, sublicensing, or providing access to the Service to third parties without the explicit permission of the Provider.",
                ],
                subsections: [
                    {
                        title: "Permitted Use",
                        paragraphs: [
                            "Users may refer to or mention the Service (including the name \"Invoitio\") in media, reviews, social posts, articles, or informational contexts, as long as such use does not imply ownership of the Service.",
                        ],
                    },
                ],
            },
            {
                title: "9. Limitation of Liability",
                paragraphs: [
                    "The Service is provided \"as is,\" and reasonable efforts are made to ensure stability and availability.",
                    "The Provider is not responsible for:",
                ],
                list: [
                    "data loss,",
                    "service interruptions or outages,",
                    "indirect, incidental, or consequential damages.",
                ],
                paragraphsAfterList: [
                    "The total liability of the Provider is limited to the amount paid by the user during the last six (6) months of use.",
                ],
            },
            {
                title: "10. Personal Data and GDPR Compliance",
                paragraphs: [
                    "The Provider processes personal data in accordance with GDPR and Czech privacy legislation. Details are described in the Privacy Policy.",
                ],
            },
            {
                title: "11. Service Availability and Updates",
                paragraphs: [
                    "Temporary maintenance periods or short interruptions may occur.",
                    "The Provider may update, modify, or improve the Service at any time to enhance functionality, security, or performance.",
                ],
            },
            {
                title: "12. Termination and Data Deletion",
                paragraphs: [
                    "Accounts may be closed:",
                ],
                list: [
                    "at the user's request,",
                    "due to prolonged inactivity,",
                    "in cases of misuse or Terms violations,",
                    "when required by law.",
                ],
                paragraphsAfterList: [
                    "After termination, user data may be deleted in accordance with legal and internal retention requirements.",
                ],
            },
            {
                title: "13. Governing Law",
                paragraphs: [
                    "These Terms are governed by the laws of the Czech Republic.",
                    "Any disputes shall be resolved by the competent courts in the Czech Republic.",
                ],
            },
        ],
    },
    privacy: {
        title: "Privacy Policy",
        sections: [
            {
                title: "1. Introduction",
                paragraphs: [
                    "This Privacy Policy explains how Alisa Zakhtarenko, OSVČ (\"Provider\") processes personal data of users of the Invoitio software-as-a-service platform (\"Service\") in compliance with the GDPR and applicable Czech data protection laws.",
                    "By using the Service, you acknowledge that you have read and understood this Policy.",
                ],
            },
            {
                title: "2. Data Controller Contact Information",
                paragraphs: [
                    "Data Controller:",
                    "Alisa Zakhtarenko, OSVČ",
                    "IČO: 21512302",
                    "Address: Praha – Vinohrady, Mánesova 1080/3, 12000",
                    "Email: support [at] invoitio [dot] com",
                ],
            },
            {
                title: "3. Personal Data We Process",
                paragraphs: [
                    "The Provider processes only the data necessary for operating the Service.",
                ],
                subsections: [
                    {
                        title: "3.1 Data provided by the user",
                        list: [
                            "email address",
                            "name (if provided)",
                            "login credentials",
                            "payment-related information (processed via payment processors; the Provider does not receive card numbers)",
                        ],
                    },
                    {
                        title: "3.2 Automatically collected data",
                        list: [
                            "IP address",
                            "device and browser information",
                            "usage logs",
                            "diagnostic and technical data",
                        ],
                    },
                    {
                        title: "3.3 Billing data",
                        list: [
                            "transaction IDs",
                            "subscription type",
                            "payment history",
                        ],
                    },
                ],
            },
            {
                title: "4. Purposes of Processing",
                paragraphs: [
                    "Personal data is processed for:",
                ],
                list: [
                    "providing and operating the Service",
                    "managing user accounts",
                    "processing payments and issuing invoices",
                    "customer support and communication",
                    "ensuring security and preventing misuse",
                    "fulfilling legal obligations (tax and accounting)",
                ],
            },
            {
                title: "5. Legal Bases for Processing",
                paragraphs: [
                    "Processing is based on:",
                ],
                list: [
                    "performance of a contract (Art. 6(1)(b) GDPR) — providing the Service",
                    "legitimate interest — improving security and functionality",
                    "legal obligation — accounting, tax records",
                    "user consent, where required (e.g., optional cookies)",
                ],
            },
            {
                title: "6. Sharing of Personal Data",
                paragraphs: [
                    "Data may be shared only with:",
                ],
                list: [
                    "payment processors (e.g., Stripe, PayPal)",
                    "hosting and infrastructure providers",
                    "accounting or tax service providers",
                    "public authorities if required by law",
                ],
                paragraphsAfterList: [
                    "The Provider does not sell personal data to third parties.",
                ],
            },
            {
                title: "7. Data Retention",
                paragraphs: [
                    "Personal data is kept only for as long as necessary for:",
                ],
                list: [
                    "providing the Service,",
                    "fulfilling legal obligations,",
                    "or until the user requests deletion.",
                ],
                paragraphsAfterList: [
                    "Billing and accounting records must be retained under Czech law (typically 5–10 years).",
                ],
            },
            {
                title: "8. User Rights Under GDPR",
                paragraphs: [
                    "Users have the right to:",
                ],
                list: [
                    "access their personal data",
                    "rectification",
                    "erasure (\"right to be forgotten\")",
                    "restriction of processing",
                    "data portability",
                    "object to processing",
                    "file a complaint with the Czech Data Protection Authority (ÚOOÚ)",
                ],
            },
            {
                title: "9. Data Security",
                paragraphs: [
                    "The Provider uses appropriate technical and organizational safeguards, including:",
                ],
                list: [
                    "encryption",
                    "secure data transmission",
                    "access restrictions",
                    "regular updates and security monitoring",
                ],
            },
            {
                title: "10. International Data Transfers",
                paragraphs: [
                    "Data may be processed within or outside the EU.",
                    "Transfers outside the EU occur only if the receiving party meets GDPR requirements (e.g., SCCs).",
                ],
            },
            {
                title: "11. Cookies",
                paragraphs: [
                    "The Service may use essential cookies to enable authentication and functionality.",
                    "Optional analytics or marketing cookies are used only with user consent.",
                ],
            },
            {
                title: "12. Changes to This Policy",
                paragraphs: [
                    "The Provider may update this Policy.",
                    "Any changes will be posted on the website.",
                    "Continued use of the Service constitutes acceptance of the updated Policy.",
                ],
            },
            {
                title: "13. Contact for GDPR Requests",
                paragraphs: [
                    "For any questions or requests regarding personal data, please contact:",
                    "support [at] invoitio [dot] com",
                ],
            },
        ],
    },
    userSettings: {
        title: "User Settings",
        general: {
            title: "General Settings",
            defaultLanguage: "Default language",
            defaultLanguageDescription: "This will be used as the default language for your account.",
            notificationEmail: "Email address for client payment notifications",
            notificationEmailHandle: "Email handle",
            notificationEmailName: "Sender name",
            notificationEmailPreview: "This is what your address will look like:",
            notificationEmailHandleErrorTaken: "This email handle is already taken",
            notificationEmailHandleErrorForbidden: "This email handle is reserved and cannot be used",
        },
        changePassword: {
            title: "Change Password",
            button: "Change Password",
            resetLinkSent: "Password reset instructions have been sent to your email.",
        },
        subscription: {
            title: "Subscription",
        },
        subscriptionUi: {
            mostPopular: "MOST POPULAR",
            bestDeal: "BEST DEAL",
            monthly: "MONTHLY",
            yearly: "YEARLY",
            perMonth: "/ month",
            perYear: "/ year",
            subscribe: "Subscribe",
            cancel: "Cancel subscription",
            lifetime: "LIFE-TIME",
            planLabel: "PLAN",
        },
        subscriptionDetails: {
            status: "Status",
            renewsAt: "Renews at",
            accessUntil: "Access until",
            notSubscribed: "Not subscribed",
            canceled: "Canceled",
            resubscribeTitle: "Resubscribe to keep your access",
            resubscribeSubtitle: "Choose a plan below to continue after your current period ends.",
        },
        paymentMessage: {
            success: "Thank you for your purchase! Your subscription is now active.",
            cancelled: "Payment was cancelled. If this was a mistake, please try again.",
        },
        paymentSuccess: {
            title: "Payment Successful! 🎉",
            subtitle: "We're glad we can help your business grow🙏🏻",
            button: "Continue working",
            team: "Invoitio Team"
        },
        emailTransferNotice: "If you need to change your email and transfer your subscription to another account, please contact us at support@invoitio.com",
        deleteAccountNotice: "If you want to delete your account, please write to us from the email with which the account was registered to support@invoitio.com",
        trial: {
            title: "Your trial period",
            subtitle: "Your trial period will end in {days} {daysLabel}",
            subscribe: "Get a 15% discount if you subscribe before {date}",
            description: "Get unlimited access to all features and professional templates.",
            remainingDays: "Days remaining",
            barAction: "Your trial period will end in {days} {daysLabel}",
            barActionLead: "Subscribe now",
            thanks: "❤️ Thanks for choosing us",
        },
        trialExpired: {
            title: "Your trial period has expired!",
            description: "Subscribe to Invoitio to continue using our service.",
            monthly: "Monthly",
            yearly: "Yearly",
            periodMonth: "/ month",
            periodYear: "/ year",
            lifetimeOffer: "Don't want to pay for a subscription? Get lifetime access to Invoitio for {price}. Offer is limited. You have {timer} left.",
            lifetimeAccess: "Full service payback in 1.5 years — get lifetime access for",
            lifetimeLimited: "Offer is limited.",
            buyNow: "Get life-time access",
            subscribe: "Subscribe",
            thanks: "Thanks for choosing us",
            downloadPreviousInvoices: "Download previously made invoices",
            downloadExpensesTable: "Download expenses table",
        },
        affiliate: {
            title: "Affiliate Program",
            referredUsersTitle: "Referred Users",
            description: "Get 30% commission from the payments of all users you refer. For life.",
            yourReferralCode: "Your Referral Code",
            copy: "Copy",
            copied: "Copied",
            table: {
                email: "Email",
                signupDate: "Signup Date",
                status: "Status",
                active: "Active",
                trial: "Trial",
                inactive: "Inactive",
            },
            bankInfo: {
                title: "Bank Details for Payouts",
                description: "Enter your bank details where you would like to receive your referral commissions.",
                accountNumber: "Account Number",
                iban: "IBAN",
                bic: "BIC",
                swift: "SWIFT",
                bankName: "Bank Name",
                bankAddress: "Bank Address",
                fullName: "Full Name",
                save: "Save Bank Details",
                saved: "Bank details saved successfully",
                errorRequired: "Please enter either Account Number or IBAN.",
            }
        },
    },
    // Blog
    blog: {
        title: "Blog",
        post1: {
            title: "Invoitio vs Fakturoid, iDoklad, and FakturyWeb: Choosing the Best Invoicing System in the Czech Republic",
            intro: "If you're looking for an invoicing service in the Czech Republic, three names almost always pop up: Fakturoid, iDoklad, and FakturyWeb. They are familiar to accountants, have been around for a long time, and cover basic tasks. Invoitio appeared later — and was originally created with a different focus: not just 'issuing an invoice', but simplifying life for freelancers, small businesses, and accountants at the same time. Below is an honest comparison without advertising slogans.",
            comparisonTitle: "Quick Comparison",
            table: {
                feature: "Feature",
                languages: "Interface Languages",
                currencies: "Currencies",
                rates: "Exchange Rates (ECB)",
                analytics: "Analytics (MRR, ARPU, LTV)",
                multiProfit: "Multi-currency Profit",
                accountingAccess: "Accountant Access",
                export: "Document Export",
                lifetime: "Life-time Access",
                speed: "Invoice Creation Speed",
                yes: "Yes",
                no: "No",
                limited: "Limited",
                partial: "Partial",
                average: "Average",
                faster: "Slower",
                seconds: "≈ 10 seconds"
            },
            focusTitle: "Invoitio — When More Than Just an Invoice Matters",
            focusText: "Invoitio was not created as 'just another invoice', but as a professional tool for those who work with clients from different countries, receive income in different currencies, and want to understand how much they earn and on what, rather than just storing invoices. The service is equally convenient for freelancers, small businesses, and accountants managing multiple clients.",
            featuresTitle: "What's Truly Convenient in Invoitio",
            feature1Title: "Languages Without Compromise",
            feature1Text: "The interface and the invoices themselves are available in five languages: Czech, English, German, Russian, and Slovak. This is a rarity for Czech services and a big plus if your clients are not only from the CZ.",
            feature2Title: "Simple and Powerful UI",
            feature2Text: "The interface is designed not to get in the way of work. Minimal screens, logical flow, nothing extra. In terms of speed and convenience, Invoitio beats most competitors — an invoice is realistically created in seconds.",
            feature3Title: "Any Currencies + Proper Conversion",
            feature3Text: "Income can be calculated in a single base currency, even if clients pay in different ones. Rates are automatically pulled from the European Central Bank (ECB). Among the compared services, only Invoitio and iDoklad offer this.",
            feature4Title: "Analytics, Not Just an Invoice List",
            feature4Text: "MRR, ARPU, LTV, income by clients and currencies — without Excel and manual calculations.",
            feature5Title: "Separate Accountant Access",
            feature5Text: "No need to share login and password. Access is included in the price — important if you work with an accountant regularly.",
            feature6Title: "Payment Without Traps",
            feature6Text: "You can choose a subscription, or you can buy lifetime access with a single payment and forget about bills for the service.",
            fakturoidTitle: "Fakturoid — Reliable but Conservative",
            fakturoidText: "Fakturoid is great for local businesses in the Czech Republic. It is stable, clear, and familiar to accountants. But: almost no analytics, weak currency handling, not very suitable for freelancers and international work. A good option if everything you do is in CZK and you have no plans for growth.",
            idokladTitle: "iDoklad — Accounting First",
            idokladText: "iDoklad is convenient when the accountant is the primary user. It handles accounting and taxes well. Cons: the interface is overloaded, analytics are limited, not the fastest for daily freelancer tasks.",
            fakturywebTitle: "FakturyWeb — The Simplest Option",
            fakturywebText: "Suitable if you just need to issue an invoice and nothing else. But: almost no automation, no analytics, limited growth opportunities.",
            conclusionTitle: "Who is Invoitio Best For?",
            conclusionText: "Invoitio is a good choice if you are: a freelancer with foreign clients, a small business owner, an accountant managing several clients, working in different currencies, wanting a simple interface and income control, or don't want to be stuck with a subscription forever."
        },
        post2: {
            title: "How to Issue an Invoice as Self-employed Person (OSVČ) in The Czech Republic?",
            intro: "Are you starting a business as a sole proprietor and wondering how to correctly issue your first invoice? Whether you are a VAT payer or not, there are rules you need to follow. In this guide, we'll walk you through everything from mandatory data to the moment you might become a VAT payer.",
            ctaTitle: "Invoice Template for Non-VAT Payers",
            ctaText: "You can generate your invoice online right now – in our free invoice generator. You'll be done in less than a minute after registration.",
            q1Title: "When Must I Issue an Invoice as a Sole Proprietor?",
            q1Text: "A non-VAT payer (OSVČ or a company with a turnover up to 2 million CZK) does not have a precise deadline set by law for issuing an invoice, unlike VAT payers. However, it is recommended to do so as soon as possible after the delivery of goods or services.",
            q2Title: "When Do You Become a VAT Payer?",
            q2Text: "You become a VAT payer in the following cases:",
            q2List: [
                "from January 1st of the following year, if your turnover for the previous calendar year exceeds 2,000,000 CZK,",
                "the day after exceeding a turnover of 2,536,500 CZK during the calendar year,",
                "if you inherit an economic activity from a person who was a VAT payer,",
                "or if you take over a business or assets as part of a privatization, merger, or division of a company."
            ],
            q2Note: "If you are just starting your business, you are likely not a VAT payer. In that case, simpler rules apply to you.",
            section1Title: "Invoices for Non-VAT Payers with Tax Records",
            section1Text: "Requirements for an invoice are based on the Civil Code, specifically Act No. 89/2012 Coll.",
            section1MandatoryTitle: "Mandatory data on the invoice:",
            section1MandatoryList: [
                "first and last name (for OSVČ) or company name,",
                "registered office of the company or OSVČ,",
                "registration details (Commercial Register including section and insert, or Trade Register),",
                "IČO (identification number)."
            ],
            section1MandatoryNote: "From a legal perspective, no other mandatory data is required.",
            section1OptionalTitle: "Non-mandatory but commonly included data:",
            section1OptionalList: [
                "customer information (usually the same range as the supplier – name, address, IČO),",
                "numerical and verbal designation of the document (e.g., FV-2025-001),",
                "description of delivered goods or provided services,",
                "amount to be paid (total or broken down by units and quantity),",
                "date of invoice issuance."
            ],
            q3Title: "What About the Due Date?",
            q3Text: "The law sets the basic due date at 30 days (which is also the maximum limit), however, it is possible to agree on a different due date with the client.",
            edgeCaseTitle: "Edge Case: Non-VAT Payer Invoice with Accounting",
            edgeCaseText: "All legal entities are obliged to keep accounts, regardless of their income level. If you have an obligation to keep accounts (e.g., as a legal entity) or have decided to do so voluntarily (e.g., OSVČ instead of tax records), the requirements for the invoice are governed by Act No. 563/1991 Coll., on Accounting.",
            edgeCaseMandatoryTitle: "A non-VAT payer invoice in accounting contains the same basic data as in tax records, but must also include:",
            edgeCaseMandatoryList: [
                "description of goods or services,",
                "invoiced amount (total or broken down by units and quantity),",
                "date of document issuance,",
                "registration details in a public register (including section and insert)."
            ],
            finalCtaTitle: "Try Invoitio for Free",
            finalCtaText: "Generate invoices in seconds and keep track of when you are approaching the threshold for becoming a VAT payer - without manual counting and without stress."
        }
    },

    // Time Tracking
    timeTracking: {
        title: "Time Tracking",
        newProject: "New Project",
        projectName: "Project Name",
        createProject: "Create Project",
        noProjects: "No projects yet. Create your first project to start tracking time.",
        addService: "Add task or service",
        serviceName: "Service name",
        hourlyRate: "Hourly rate",
        dailyRate: "Daily rate",
        fixedPrice: "Fixed price",
        rate: "Price",
        totalTime: "Total time",
        totalAmount: "Total price",
        billed: "Billed",
        notBilled: "Not billed",
        generateInvoice: "Generate Invoice",
        selectItems: "Select items to invoice",
        timerRunning: "Timer is running",
        timerPaused: "Timer paused",
        units: {
            hourly: "/ hour",
            daily: "/ day",
            fixed: "fix"
        },
        deleteModal: {
            titleProject: "Delete Project",
            messageProject: "Are you sure you want to delete this project? All associated tasks and time tracks will be permanently removed.",
            titleTask: "Delete Task",
            messageTask: "Are you sure you want to delete this task? This action cannot be undone.",
            confirm: "Delete",
            cancel: "Cancel"
        }
    },
};
